import React from 'react';
import { MessageSquare, ArrowRight, Check, ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const WhatsAppButtonPage = () => {
  const { login } = useAuth();

  const features = [
    'Botão flutuante personalizável',
    'Abre WhatsApp diretamente',
    'Mensagem pré-definida',
    'Fácil instalação',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <MessageSquare className="h-4 w-4" />
                WhatsApp Chat Button
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Botão de <span className="text-green-500">WhatsApp</span> para seu site
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Adicione um botão flutuante de WhatsApp ao seu site e receba mais mensagens.
              </p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                Começar gratuitamente
              </Button>
            </div>
            <div className="relative bg-gray-100 rounded-3xl p-8 h-80">
              <div className="absolute bottom-8 right-8">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-lg cursor-pointer hover:scale-110 transition-transform">
                  <MessageSquare className="h-8 w-8 text-white" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Adicione o botão ao seu site</h2>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default WhatsAppButtonPage;
